// @flow
import { StyledEngineProvider, Theme, ThemeProvider } from '@mui/material'
import StylesProvider from '@mui/styles/StylesProvider'
import { SnackbarProvider } from 'notistack'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { SNACK_BAR_PROPS } from '../../../pure-js/libs/Consts'
import RoutePath from '../../../pure-js/libs/RoutePath'
import { Context, useAppStateContext } from '../hooks/useAppState'
import '../libs/Fonts'
import theme from '../libs/theme'
import ErrorBoundaryProvider from './ErrorBoundaryProvider'

import { Toaster } from 'react-hot-toast'
import { SessionContext, useAppStateSessionContext } from '../hooks/useAppStateSession'
import { OnMountApp } from '../hooks/useOnMountApp'
import { CollaborationProgressPage } from '../pages/CollaborationProgressPage'
import { DashboardPage } from '../pages/DashboardPage'
import { InvitePage } from '../pages/InvitePage'
import { JoinTeamPage } from '../pages/JoinTeamPage'
import { OnboardingPage } from '../pages/OnboardingPage'
import { PlayGamePage, PlayGameWithIntroductionPage, PlayGameWithoutIntroductionPage } from '../pages/PlayGamePage'
import { ProfilePage } from '../pages/ProfilePage'
import { RootPage } from '../pages/SignInPage'
import { TheoryBehindPage } from '../pages/TheoryBehindPage'
import { Helmet } from './Helmet'
import SandboxPage from './SandboxPage'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const App = () => {
  const context = useAppStateContext()
  const sessionContext = useAppStateSessionContext()

  return (
    <ErrorBoundaryProvider>
      <StylesProvider injectFirst>
        <SnackbarProvider {...SNACK_BAR_PROPS}>
          <Context.Provider value={context}>
            <SessionContext.Provider value={sessionContext}>
              <BrowserRouter>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={theme}>
                    <Helmet titleTemplate="%s - Intraction" />
                    <OnMountApp />
                    <Toaster position="top-center" reverseOrder={false} toastOptions={{ duration: 2000 }} />
                    <Routes>
                      <Route path={RoutePath.ROOT} Component={RootPage}>
                        <Route path={RoutePath.DASHBOARD} Component={DashboardPage} />
                        <Route path={RoutePath.PROFILE} Component={ProfilePage} />
                        <Route path={RoutePath.GAME_CENTER} Component={PlayGamePage} />
                        <Route
                          path={RoutePath.PLAY_GAME_WITHOUT_INTRODUCTION}
                          Component={PlayGameWithoutIntroductionPage}
                        />
                        <Route path={RoutePath.PLAY_GAME_WITH_INTRODUCTION} Component={PlayGameWithIntroductionPage} />
                        <Route path={RoutePath.COLLABORATION} Component={CollaborationProgressPage} />
                        <Route path={RoutePath.THEORY_BEHIND} Component={TheoryBehindPage} />
                        <Route path={RoutePath.ONBOARDING} Component={OnboardingPage} />
                        <Route path={RoutePath.INVITE} Component={InvitePage} />
                        <Route path={RoutePath.JOIN_TEAM} Component={JoinTeamPage} />
                      </Route>
                      <Route path={RoutePath.SANDBOX} Component={SandboxPage} />
                    </Routes>
                  </ThemeProvider>
                </StyledEngineProvider>
              </BrowserRouter>
            </SessionContext.Provider>
          </Context.Provider>
        </SnackbarProvider>
      </StylesProvider>
    </ErrorBoundaryProvider>
  )
}

export default App

//
